import React from 'react';
import { Box, Button, Typography } from '@material-ui/core';

interface Props {
  onClick?(): any;
  cannotSaveMessages: string[];
}

/**
 * Composant de bouton de sauvegarde avec validation
 * 
 * Ce composant affiche :
 * - Un bouton "Enregistrer" avec état désactivé si des erreurs existent
 * - Une liste des messages d'erreur empêchant la sauvegarde
 * - Support pour les actions onClick personnalisées
 * 
 * Logique métier :
 * - Désactivation du bouton si des messages d'erreur sont présents
 * - Affichage des erreurs de validation sous forme de liste
 * - Support des formulaires (type="submit") ou actions personnalisées
 * 
 * @param onClick Fonction appelée lors du clic (optionnelle)
 * @param cannotSaveMessages Liste des messages d'erreur empêchant la sauvegarde
 * @returns Composant React du bouton de sauvegarde
 */
export const SaveButton: React.FC<Props> = ({
  cannotSaveMessages,
  onClick
}) => {
  return (
    <Box display="flex" flexDirection="column">
      <Button
        color="secondary"
        variant="contained"
        disabled={cannotSaveMessages.length > 0}
        type={onClick ? 'button' : 'submit'}
        onClick={onClick}
      >
        Enregistrer
      </Button>
      {cannotSaveMessages.length > 0 && (
        <Box display="block">
          <ul>
            {cannotSaveMessages.map((message, index) => (
              <li key={index}>
                <Typography color={'error'}>{message}</Typography>
              </li>
            ))}
          </ul>
        </Box>
      )}
    </Box>
  );
};
